module.exports = __webpack_public_path__ + "7404bfb7706b1d3bbaddfd826197835a.png";